import Apollo from '@/store/interface/Apollo'
import gql from 'graphql-tag'
import { storage } from '@/utils/storage'

const apollo = new Apollo(process.env.VUE_APP_CRAFT_API, false)
apollo.setToken('Bearer ' + process.env.VUE_APP_CRAFT_TOKEN)
const graphqlClient = apollo.client

const site = process.env.VUE_APP_CRAFT_WEBSITE

const subject = `
sbsSubject {
  ... on sbsSubject_Tag {
    id
    title
    sbsgradient
  }
}`

const media = `
id
slug
title
sectionHandle
sousTitre
sbsDuration
date
image {
  id
  width
  height
}
sbsAuthor {
  ... on sbsAuthor_sbsAuthor_Entry {
    id
    slug
    title
    sousTitre
  }
}
${subject}`

const medias = `
id
... on sbsArticle_sbsArticle_Entry {
  ${media}
  wysiwyg
}
... on sbsPdf_sbsPdf_Entry {
  ${media}
  sbsPdfUrl
}
... on sbsPpt_sbsPpt_Entry {
  ${media}
  sbsPptUrl
}
... on sbsVideo_sbsVideo_Entry {
  ${media}
  sbsIdVimeo
  sbsVideo {
    url
  }
  sbsSubtitles {
    url
  }
}`

class APICraft {

  getGlobal () {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchGlobal {
            globalSet (site: "${site}") {
              ... on sbsTown_GlobalSet {
                name
                sbsTutorials {
                  mobileText
                  text
                }
                sbsDistricts {
                  ... on sbsdistricts_sbsdistricts_Entry {
                    id
                    slug
                    title
                    visible
                    sbsKeypoints {
                      ... on sbsKeypoints_keypoints_BlockType {
                        titre
                        slugg
                        positionX
                        positionY
                        positionZ
                        id
                        entries {
                          ${medias}
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        `
      })
      .then(res => {
        const result = res.data.globalSet

        resolve(result)
        storage.setItem( `fetchGlobal_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchGlobal_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  getFavorites (ids) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchFavorites ($id: [QueryArgument]) {
            entries (site: "${site}", id: $id, status: "live") {
              ${medias}
            }
          }
        `,
        variables: { id: ids }
      })
      .then(res => {
        const result = res.data.entries

        resolve(result)
        storage.setItem( `fetchFavorites_${JSON.stringify(args)}`, result)
      })
      .catch(err => {
        console.error('Error catching global params ', err)
      })
    })
    const cache = storage.getItem( `fetchFavorites_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }

  searchEntries (args) {
    return new Promise((resolve, reject) => {
      graphqlClient.query({
          query: gql`
            query search ($search: String, $site: [String], $subject: [QueryArgument], $types: [String]) {
              entries(search: $search, site: $site, sbsSubject: $subject, section: $types) {
                ${medias}
              }
            }
          `,
          variables: { search: args.search, subject: args.subjects, types: args.types, site: site }
        })
        .then(res => {
          const result = res.data.entries

          resolve(result)
        })
        .catch(err => {
          console.error('Error catching global params ', err)
        })
    })
  }

  imgSize ({id, width, height}) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      let query = {}

      if (width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int, $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(width: $width, immediately: true, height: $height)
                }
              }
            }
          `,
          variables: { id, width, height }
        }
      }
      else if (width && !height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(width: $width, immediately: true)
                }
              }
            }
          `,
          variables: { id, width }
        }
      }
      else if (!width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $height: Int) {
              asset(id: $id) {
                ... on default_Asset {
                  url(height: $height, immediately: true)
                }
              }
            }
          `,
          variables: { id, height }
        }
      }
      else {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument])  {
              asset(id: $id) {
                ... on default_Asset {
                  url
                }
              }
            }
          `,
          variables: { id }
        }
      }

      graphqlClient.query(query)
        .then(res => {
          resolve(res.data.asset.url)

          const result = res.data.asset.url

          resolve(result)
          storage.setItem( `fetchImg_${JSON.stringify(args)}`, result)
        })
        .catch(err => {
          console.error('Error catching global params ', err)
        })
    })

    const cache = storage.getItem(`fetchImg_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }
}

export const api = new APICraft()